const MapsLegacy = (() => {
    let contentWindow = null;

    const addMarkerToMap = (map, location, iconPath) => new google.maps.Marker({
        position: location,
        map: map,
        draggable: false,
        icon: iconPath
    });

    const addstaticwindow = (content, map, marker) => {
        contentWindow = new google.maps.InfoWindow({
            content: content
        });
        contentWindow.open(map, marker);
    }

    const addPopupWindow = (nodeId, marker, map) => {
        google.maps.event.addListener(marker, 'click', () => {
            if (typeof contentWindow === "object") {
                contentWindow.close();
                contentWindow = null;
            }

            fetch(`/umbraco/api/MapPointer/ServiceLocationContent?nodeId=${nodeId}`)
                .then(response => response.text())
                .then(response => addstaticwindow(response, map, marker));
        });
    }

    const addMarkersFromPage = (map, scope) => {
        const bounds = new google.maps.LatLngBounds();
        const icon = scope.dataset.mapIcon;

        document.querySelectorAll('[data-plugin="filteritem"]')
            .forEach(elm => {
                const latLng = new google.maps.LatLng(elm.dataset.pointlatitude, elm.dataset.pointlongitude);

                const marker = new google.maps.Marker({
                    'position': latLng,
                    'icon': icon,
                    map: map
                });
                bounds.extend(marker.position);
                marker.addListener('click', () => {
                    addstaticwindow(elm.dataset.mapcontent, map, marker);
                });
            });

        map.fitBounds(bounds);
    }

    const getServiceLocationMarkers = (map, scope) => {
        const existingQueryString = new UrlSearchParams(location);
        const ourQueryString = new UrlSearchParams();

        ourQueryString.set("services", existingQueryString.get("services"));
        ourQueryString.set("facilities", existingQueryString.get("facilities") || existingQueryString.get("Condition"));
        ourQueryString.set("nodeId", f.dataset.nodeid);
        ourQueryString.set("sectionId", existingQueryString.get("SectionId") || document.getElementById("SectionId").value);

        const nodeId = scope.dataset.nodeid;
        const icon = scope.dataset.mapIcon;
        const addInfoWindow = scope.dataset.mapInfoWindow;
        const clickToShowInfo = scope.dataset.mapClickToShowInfo;

        return fetch(`/umbraco/api/MapPointer/ServiceLocation?${ourQueryString}`)
            .then(response => response.json())
            .then(response => {
                const makers = [];
                const bounds = new google.maps.LatLngBounds();

                response
                    .filter(x => x.latitude && x.longitude)
                    .forEach((x, i) => {
                        const latLng = new google.maps.LatLng(x.Latitude, x.Longitude);

                        const marker = new google.maps.Marker({
                            'position': latLng,
                            'icon': icon + scope.Colour,
                            map: map,
                            id: `point${i + 1}`
                        });
                        makers.push(marker);
                        bounds.extend(marker.position);

                        if (addInfoWindow) {
                            addPopupWindow(nodeId, marker, map);
                        }

                        if (clickToShowInfo) {
                            marker.addListener('click', () => {
                                document.querySelector(".map-info-pop").style.display = "none";

                                const infoSection = document.getElementById(marker.get("id"));
                                infoSection.style.top = (map.offsetTop + 200);
                                infoSection.style.left = (map.offsetLeft + 50);
                                infoSection.style.display = "";
                            });
                        }
                    });

                map.fitBounds(bounds);
            });
    }

    const createMultipMarkerMap = (scope) => {
        const latitude = scope.dataset.mapLatitude;
        const longitude = scope.dataset.mapLongitude;
        const zoom = scope.dataset.mapZoom;
        const mapType = scope.dataset.mapType;
        const icon = scope.dataset.mapIcon;
        const scrollWheel = scope.dataset.mapScrollwheel;

        const location = new google.maps.LatLng(latitude, longitude);

        const options = {
            zoom: zoom,
            mapTypeId: google.maps.MapTypeId[mapType],
            scrollwheel: scrollWheel,
            disableDefaultUI: true,
            zoomControl: true,
            maxZoom: scope.dataset.mapMaxzoom
        };

        const canvas = scope.querySelector(".map");

        const map = new google.maps.Map(canvas, options);

        const actualMode = scope.dataset.mapMode;
        const markers = scope.dataset.mapMarkers;

        if (actualMode === "serviceLocations") {
            getServiceLocationMarkers(map, scope);
        }
        else if (actualMode === "pageread") {
            addMarkersFromPage(map, scope);
        }
        else if (actualMode === "multiple") {
            addMarkerToMap(map, location, icon);

            if (markers) {
                JSON.parse(markers).forEach(item => {
                    addMarkerToMap(map, item.position, item.imageUrl);
                });
            }
        }
        else {
            console.error("current multi-mode not supported.");
        }
    }

    const createSingleMarkerMap = scope => {
        const latitude = scope.dataset.mapLatitude;
        const longitude = scope.dataset.mapLongitude;
        const mapType = scope.dataset.mapType;
        const icon = scope.dataset.mapIcon;

        const location = new google.maps.LatLng(latitude, longitude);

        const options = {
            zoom: parseInt(scope.dataset.mapZoom),
            center: location,
            mapTypeId: google.maps.MapTypeId[mapType],
            scrollwheel: scope.dataset.mapScrollwheel === "true"
        };

        const canvas = scope.querySelector(".map");

        const map = new google.maps.Map(canvas, options);
        addMarkerToMap(map, location, icon);

        return map;
    }

    let lazyLoadingScopes = [];

    const bindMap = scope => {
        if (typeof google !== "object" || typeof google.maps !== "object") {
            if (!lazyLoadingScopes.length) {
                const scriptElm = document.createElement("script");
                scriptElm.src = `https://maps.googleapis.com/maps/api/js?${scope.dataset.mapkey.trim() ? `key=${scope.dataset.mapkey.trim()}&` : ""}callback=lazyLoadedLegacyGoogleMaps`;
                scriptElm.tyle = "text/javascript";

                document.querySelector("head").appendChild(scriptElm);
            }

            lazyLoadingScopes.push(scope);
            return;
        }

        if (scope.dataset.mapMode.toLowerCase() !== 'single') {
            return createMultipMarkerMap(scope);
        }

        return createSingleMarkerMap(scope);
    }

    const lazyLoaded = () => {
        lazyLoadingScopes.forEach(scope => bindMap(scope));
        lazyLoadingScopes = [];
    }

    window.lazyLoadedLegacyGoogleMaps = lazyLoaded;

    const bind = (scope) => {
        if (scope.id === "map-placeholder") {
            const mapContainer = scope.closest(".map");

            scope.addEventListener("click", () => {
                scope.style.display = "none";
                mapContainer.querySelector("#map-canvas").style.display = "";
                mapContainer.dataset.mapProvider = "google";

                bindMap(mapContainer);
            });
        }
        else {
            bindMap(scope);
        }
    }

    return { bind, lazyLoaded };
})();

ControlBinders.register("[data-map-provider='google']", MapsLegacy.bind);
ControlBinders.register("img#map-placeholder", MapsLegacy.bind);